
<script type="text/jsx">
import md5 from './md5'
import moment from 'moment'
import env from '../config/env'
import ActivityCard from './activityCard'
import cardBag from './card-slot/card'
import cardRoll from './card-slot/roll'
import salesCard from './card-slot/salesCard'
import Vue from 'vue'
// import axios from 'axios'
export default {
        // 组件名称
    name: 'AnchoredHeading',
    props: {
        html: {
            type: String,
        },
        id:{
            type: String,
            default: '',
        },
        shareId:{
            type: Object,
            default: function() {
                return ""
            }
        },
        vcardData:{
          type: Object,
            default: function() {
                return {}
            }
        },
        vcardUrl:{
            type: String,
            default: '',
        },
    },
    // 父组件data数据更新，子组件刷新
    watch:{
      html(value){
        console.log('html--------:',value);
        this.html = value;

        console.log('watch====','数据更新了'); 
        this.init();
      },
      id(value){
        console.log('id-----:',value);
        this.id = value;
      },
      shareId(value){
        console.log('shareId-----:',value);
        this.shareId = value;
      },
      vcardData(value){
        console.log('vcardData-----:',value);
        this.vcardData = value;
      },
      vcardUrl(value){
        console.log('vcardUrl:------',value);
        this.vcardUrl = value;
      },
    },
    data(){
      return {
          md5:md5,
          env: env,
          moment:moment,
          cardDetailHtml:'',
           showTip: false,
            current: {},
            nopassText: [],
            colorMap: {
            审核中: '#EB5757',
            未通过: '#EB5757',
            审核失败: '#EB5757',
            进行中: '#52C41A',
            已结束: '#FAAD14',
            未开始: '#2F80ED',
            },
            timeType: '',
            color: {
            over: '#EBEDF0',
            start: '#FDF6C9',
            end: '#FFEEE8'
            },
            textColor: {
            over: '#4A4A4A',
            start: '#49410F',
            end: '#A20606'
            },
      }
    },
    mounted(){
      this.init()
    },
    methods:{
      async init(){
      let hText=''
      if(this.html){
            hText=this.html;
            if(hText){
                 if(this.shareId){
                   if(typeof this.shareId==='object'){
                     console.log('对象')
                   }else{
                     if(typeof this.shareId==='string'){
                        this.shareId=JSON.parse(this.shareId)
                      }else{
                        var strJson = JSON.stringify(this.shareId);
                        this.shareId = JSON.parse(strJson);
                      }
                   }
                    console.log('this.shareId',this.shareId)
                 }
                let contentSlotList=await this.getContentSlotList(this.shareId);
                // let contentSlotList=[{"contentId":"456","sellerId":"8ae483d37432c05c01746b316ff90007","cardSlotId":"3","entityId":"8ae4263074d87c570174d8d8e8870127","entityType":"couponPackage","createdTime":"2020-10-20T07:44:40Z","createdBy":"8ae483d37432c05c01746b316ff90007"},{"contentId":"456","sellerId":"8ae483d37432c05c01746b316ff90007","cardSlotId":"1","entityId":"8ae4078b7530c91501753566a8a00076","entityType":"seckill","createdTime":"2020-10-20T07:44:40Z","createdBy":"8ae483d37432c05c01746b316ff90007"},{"contentId":"456","sellerId":"8ae483d37432c05c01746b316ff90007","cardSlotId":"2","entityId":"8ae42620753ed40c01753f0b6b450040","entityType":"seckill","createdTime":"2020-10-20T07:44:40Z","createdBy":"8ae483d37432c05c01746b316ff90007"}]
                console.log('contentSlotList',contentSlotList)
                hText =hText.replace(/section/gi, "div");
                var str = hText;
                let index = str.indexOf('data-mpa-template="t" data-mpa-tezign-banner-slot="t"'); // 字符出现的位置
                let num = 1; // 这个字符出现的次数
                let numList=[];
                console.log('index',index)
                while(index !== -1) {
                    console.log('num',num)
                    hText =hText.replace('data-mpa-template="t" data-mpa-tezign-banner-slot="t"', `id='data-mpa-tezign-banner-slot${num}' style="display:none"`);
                    numList.push(num)
                    num++; // 每出现一次 次数加一
                    index = str.indexOf('data-mpa-template="t" data-mpa-tezign-banner-slot="t"',index + 1); // 从字符串出现的位置的下一位置开始继续查找
                }
                console.log('numList',numList)
                this.cardDetailHtml= hText
                this.$nextTick(async function(){
                    console.log('contentSlotList',contentSlotList)
                    if(contentSlotList&&contentSlotList.length>0){
                        let seckillList=[],seckillCardSlotId=[];
                        for(let i=0;i<contentSlotList.length;i++){
                            let x=contentSlotList[i];
                            if(x.cardSlotId){
                              let shareIdDetail='';
                              for (var key in this.shareId) {
                                if(key==x.cardSlotId){
                                  shareIdDetail=this.shareId[key]
                                }
                              }
                            let activityHtml=""; 
                            let string=`data-mpa-tezign-banner-slot${x.cardSlotId}`;
                            console.log('string',string)
                            let pattern = new RegExp("("+string+"')([\\s\\S]*?)(?=</div>)");
                            if(pattern.test(hText)){
                                let matchResult = hText.match(pattern)[0]
                                if(x.entityType==='ACTIVITY'){
                                  let activityDetail = await this.getActivityDetail(x.entityId,shareIdDetail);
                                  let contentShareId=this.shareId.contentShareId
                                     let vcard=this.vcardData
                                    let url=this.vcardUrl
                                  let MyComponent = Vue.extend({
                                          template: '<div class="activityCard"><ActivityCard :item="detail" :shareId="shareId" :vcardData="vcardData" :vcardUrl="vcardUrl" :pagesType="pagesType"/></div>',
                                          components: {ActivityCard},
                                          data:function(){
                                            return {
                                              detail:activityDetail,
                                              shareId:contentShareId,
                                              vcardData:vcard,
                                              vcardUrl:url,
                                              pagesType:'slot'
                                            }
                                          }
                                        })
                                  new MyComponent().$mount(`#data-mpa-tezign-banner-slot${x.cardSlotId}`)
                                }
                                if(x.entityType==='RIGHTS_COUPON'){
                                    let rollDetail = await this.getRollDetail(x.entityId,shareIdDetail);
                                    let contentShareId=this.shareId.contentShareId
                                    let vcard=this.vcardData
                                    let url=this.vcardUrl
                                  let MyComponent = Vue.extend({
                                          template: '<div class="activityCard"><cardRoll :rollDetail="detail" :shareId="shareId" :vcardData="vcardData" :vcardUrl="vcardUrl"/></div>',
                                          components: {cardRoll},
                                          data:function(){
                                            return {
                                              detail:rollDetail,
                                              shareId:contentShareId,
                                              vcardData:vcard,
                                              vcardUrl:url
                                            }
                                          }
                                        })
                                  new MyComponent().$mount(`#data-mpa-tezign-banner-slot${x.cardSlotId}`)
                                    
                                }
                                if(x.entityType==='RIGHTS_CARD_BAG'){
                                    let cardDetail = await this.getCardDetail(x.entityId,shareIdDetail);
                                     let contentShareId=this.shareId.contentShareId
                                     let vcard=this.vcardData
                                    let url=this.vcardUrl
                                    let MyComponent = Vue.extend({
                                          template: '<div class="activityCard"><div id="activityDetail" class="card-detail" style="margin:12px 0;"><cardBag :cardData="detail" :shareId="shareId" :vcardData="vcardData" :vcardUrl="vcardUrl"></cardBag></div></div>',
                                          components: {cardBag},
                                          data:function(){
                                            return {
                                              detail:cardDetail,
                                              shareIdDetail:shareIdDetail,
                                              shareId:contentShareId,
                                              vcardData:vcard,
                                              vcardUrl:url
                                            }
                                          }
                                        })
                                    new MyComponent().$mount(`#data-mpa-tezign-banner-slot${x.cardSlotId}`)
                                }
                                if(x.entityType==='RIGHTS_SPIKE'){
                                    let seckillDetail = await this.getSeckillDetail(x.entityId,shareIdDetail);
                                    seckillList.push({...seckillDetail,cardSlotId:x.cardSlotId});
                                    seckillCardSlotId.push(x.cardSlotId);
                                }
                                if(activityHtml){
                                    hText =hText.replace(matchResult, activityHtml);
                                    }
                            }  
                            }
                        }
                        if(seckillList.length>0){
                            if(seckillCardSlotId.length>0){
                                seckillCardSlotId.forEach(x=>{
                                if(seckillList[seckillList.length-1].cardSlotId!=x){
                                     let MyComponent = Vue.extend({
                                          template: '<div></div>',
                                        })
                                    new MyComponent().$mount(`#data-mpa-tezign-banner-slot${x}`)
                                }
                                })
                                let string=`data-mpa-tezign-banner-slot${seckillList[seckillList.length-1].cardSlotId}`;
                                let pattern = new RegExp("("+string+"')([\\s\\S]*?)(?=</div>)");
                                let contentShareId=this.shareId.contentShareId
                                console.log('contentShareId',contentShareId)
                                let vcard=this.vcardData
                                let url=this.vcardUrl
                                if(pattern.test(hText)){
                                    let MyComponent = Vue.extend({
                                          template: '<div class="activityCard"><div class="flash-sales" style="margin:12px 0;"><salesCard :list="detail" :shareId="shareId" :vcardData="vcardData" :vcardUrl="vcardUrl"></salesCard> </div></div>',
                                          components: {salesCard},
                                          data:function(){
                                            return {
                                              detail:seckillList,
                                              shareId:contentShareId,
                                              vcardData:vcard,
                                              vcardUrl:url
                                            }
                                          }
                                        })
                                    new MyComponent().$mount(`#data-mpa-tezign-banner-slot${seckillList[seckillList.length-1].cardSlotId}`)
                                }
                            }
                        }
                    }else{
                      if(numList.length>0){
                         numList.forEach(x=>{
                           let MyComponent = Vue.extend({
                              template: '<div></div>',
                            })
                            new MyComponent().$mount(`#data-mpa-tezign-banner-slot${x}`)

                         })
                      }
                    }
                })
            }
  
      }
      },
   //查询内容卡槽列表内容
    getContentSlotList(share){
      if(!share){
        return []
      }
      let shareId=share&&share.contentShareId ? '/'+share.contentShareId:''
      let url =`aocampaign/openapi/tezign/ContentSlotList/${this.id}${shareId}`
      return new Promise((s) => {
        if(share&&share.contentShareId){
          this.$http
          .get(url)
          .then((res) => {
            let datail = res.data;
            s(datail)
          }).catch(() => {
               s([])
          })
        }else{
          s([])
        }
       })
    },
    //卡槽活动回显
     getActivityDetail(id,shareIdDetail){
      const timestamp = new Date().getTime()
      const sign = md5.hexMD5(`${id}${timestamp}!_activity_info_!`)
      return new Promise((s) => {
        this.$http
          .get(
            `aocampaign/openapi/activity/logout/info/${id}?sign=${sign}&timestamp=${timestamp}&shareId=${shareIdDetail}`
          )
          .then((res) => {
            let datail = {
              startTime:moment(res.data.startTime).format('YYYY-MM-DD'),
              startHm:moment(res.data.startTime).format('HH:mm'),
              endTime:moment(res.data.endTime).format('YYYY-MM-DD'),
              endHm:moment(res.data.endTime).format('HH:mm'),
              bannerUrl:res.data.bannerUrl,
              activityName:res.data.activityName,
              activityStatusName:res.data.activityStatusName,
              activityId:res.data.activityId,
              activityStatus:res.data.activityStatus,
              enter:res.data.enter,
              authRole:res.data.authRole,
            };
            s(datail)
          })
       })
    },
    //卡槽卡券回显
     getRollDetail(id,shareIdDetail){
      let url =`aocampaign/openapi/coupon/achieve/info?couponId=${id}&shareId=${shareIdDetail}`
       return new Promise((s) => {
          this.$http
          .get(url)
          .then((res) => {
                let datail = res.data;
                if(datail.ladders&&datail.ladders.length>0){
                  let xx=0;
                  let dd=0
                  for(let j=0;j<datail.ladders.length;j++){
                    if(datail.ladders[0].couponAmount>0){
                      xx=datail.ladders[0].couponAmount
                      if(j>0){
                        dd=datail.ladders[j].couponAmount
                      }
                    }
                  }
                  datail={...res.data,xx:xx,dd:dd,discountType:'LADDER'}
                }
                datail.expiredDate = moment(datail.expiredDate).format("YYYY-MM-DD");
                s(datail)
          })
       })
    },
    //卡槽卡包回显
    getCardDetail(id,shareIdDetail){
      let url =`aocampaign/openapi/coupon/package/rights-package-detail/${id}?shareId=${shareIdDetail}`;
       return new Promise((s) => {
         this.$http
          .get(url)
          .then((res) => {   
            let datail = res.data;
            datail.expiredTime =moment(datail.expiredDate).format("YYYY-MM-DD");
             s(datail)
           })
       })
    },
      //卡槽秒杀回显
    getSeckillDetail(id,shareIdDetail){
      let url =`aoseckill/openapi/user/seckillRightsInterestResource/detail/${id}?shareId=${shareIdDetail}`
       return new Promise((s) => {
      this.$http
          .get(url)
          .then((res) => { 
             let datail = res.data;
             s(datail)
          })
      })
    },
     
    },
    render() {
        return (<div domPropsInnerHTML={this.cardDetailHtml} class="rich"></div>)
     }
     
}
</script>
<style  lang="less">
.rich {
  padding: 0 16px;
  overflow-y: inherit;
}
._a {
  display: inline;
  padding: 1.5px 0 1.5px 0;
  color: #366092;
  word-break: break-all;
}

._hover {
  text-decoration: underline;
  opacity: 0.7;
}

._visited {
  color: #551a8b;
}

._img {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
}

/* 内部样式 */
:host {
  display: inline;
}

._blockquote,
._div,
._p,
._ul,
._ol,
._li {
  display: block;
}

._b,
._strong {
  font-weight: bold;
}

._code {
  font-family: monospace;
}

._del {
  text-decoration: line-through;
}

._em,
._i {
  font-style: italic;
}

._h1 {
  font-size: 2em;
}

._h2 {
  font-size: 1.5em;
}

._h3 {
  font-size: 1.17em;
}

._h5 {
  font-size: 0.83em;
}

._h6 {
  font-size: 0.67em;
}

._h1,
._h2,
._h3,
._h4,
._h5,
._h6 {
  display: block;
  font-weight: bold;
}

._image {
  display: block;
  width: 100%;
  height: 360px;
  margin-top: -360px;
  opacity: 0;
}

._ins {
  text-decoration: underline;
}

._li {
  flex: 1;
  width: 0;
}

._ol-bef {
  width: 36px;
  margin-right: 5px;
  text-align: right;
}

._ul-bef {
  margin: 0 12px 0 23px;
  line-height: normal;
}

._ol-bef,
._ul-bef {
  flex: none;
  user-select: none;
}

._ul-p1 {
  display: inline-block;
  width: 0.3em;
  height: 0.3em;
  overflow: hidden;
  line-height: 0.3em;
}

._ul-p2 {
  display: inline-block;
  width: 0.23em;
  height: 0.23em;
  border: 0.05em solid black;
  border-radius: 50%;
}

._q::before {
  content: '"';
}

._q::after {
  content: '"';
}

._sub {
  font-size: smaller;
  vertical-align: sub;
}

._sup {
  font-size: smaller;
  vertical-align: super;
}

.__bdi,
.__bdo,
.__ruby,
.__rt {
  display: inline-block;
}

._video {
  position: relative;
  display: inline-block;
  width: 300px;
  height: 225px;
  background-color: black;
}
.activityCard{
  font-family: Arial, Helvetica, sans-serif;
  box-sizing: border-box;
  font-weight:normal;
  letter-spacing:normal;
  line-height: normal;
}
._video::after {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -15px 0 0 -15px;
  content: '';
  border-color: transparent transparent transparent white;
  border-style: solid;
  border-width: 15px 0 15px 30px;
}
.card-detail{
  height: 128px;
  background-size: 100%;
  background-repeat: no-repeat;
  text-align: left;
  // position: absolute;
  // left:0;
  width:100%
}
.cardSlotListNone{
  display:none
}
.activityCard{
  position: relative;
}
.van-ellipsis{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.van-multi-ellipsis--l2{-webkit-line-clamp:2}.van-multi-ellipsis--l2,.van-multi-ellipsis--l3{display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical}.van-multi-ellipsis--l3{-webkit-line-clamp:3}
</style>
